<template>
    <div class="dc-background">
        <div class="bg-connect" />
        <div class="bg-gradient" />
        <b-container fluid>
            <b-row class="fullheight">
                <b-col md="auto">
                    <div class="non-mobile-landscape">
                        <a
                            href="https://cliovis.com"
                            target="_blank"
                            style="margin-left: 5px;"
                        ><img
                            alt="cliovis logo"
                            style="margin: auto; width: 55vmin; min-width: 250px; max-width: 425px"
                            src="../assets/images/logo_blue.png"
                        ></a>
                    </div>
                    <b-card-group>
                        <b-card
                            no-body
                            class="p-3 login-card"
                        >
                            <b-card-body>
                                <b-form>
                                    <h4>Welcome to ClioVis</h4>
                                    <p class="text-muted">
                                        Log in or create an account
                                    </p>
                                    <b-form @keydown="keypress">
                                        <b-input-group class="mb-3">
                                            <b-input-group-prepend><b-input-group-text><i class="fas fa-user" /></b-input-group-text></b-input-group-prepend>
                                            <b-form-input
                                                v-model="formData.username"
                                                aria-label="email or username"
                                                type="text"
                                                class="form-control"
                                                placeholder="Email or Username"
                                                autocomplete="username"
                                            />
                                        </b-input-group>
                                        <b-input-group class="mb-4">
                                            <b-input-group-prepend><b-input-group-text><i class="fas fa-lock" /></b-input-group-text></b-input-group-prepend>
                                            <b-form-input
                                                v-model="formData.password"
                                                aria-label="password"
                                                :type="passwordInputType"
                                                class="form-control"
                                                placeholder="Password"
                                                autocomplete="current-password"
                                            />
                                            <b-input-group-append style="position: absolute; right: 0; z-index: 100">
                                                <b-btn
                                                    variant="Transparent"
                                                    style="padding-top: 7px; width: 48px"
                                                    aria-label="show or hide password"
                                                    @click="clickPasswordInputType()"
                                                >
                                                    <i
                                                        :class="passwordInputType == 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"
                                                        style="font-size: 20px; color: #182e52"
                                                    />
                                                </b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-row no-gutters>
                                            <b-col
                                                cols="7"
                                                style="min-width: 225px"
                                            >
                                                <b-button
                                                    v-if="!attemptingLogin"
                                                    variant="cliovis-blue-light"
                                                    style="font-weight: 500; width: 115px"
                                                    @click="clickLogin"
                                                >
                                                    Log In
                                                </b-button>
                                                <b-button
                                                    v-else
                                                    variant="outline-cliovis-blue-light"
                                                    style="font-weight: 500; width: 115px"
                                                >
                                                    Log In
                                                </b-button>

                                                <b-button
                                                    variant="outline-cliovis-grey-extraDark"
                                                    style="margin-left: 5px; font-weight: 500; width: 115px"
                                                    @click="clickSignUp"
                                                >
                                                    Register
                                                </b-button>
                                            </b-col>
                                            <b-col
                                                md="auto"
                                                class="text-right"
                                            >
                                                <b-button
                                                    variant="link"
                                                    class="px-0"
                                                    style="color: #396aba; font-weight: 500"
                                                    @click="clickForgotPassword"
                                                >
                                                    Forgot password?
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                        <b-row
                                            v-if="googleLoginEnabled"
                                            style="margin-top: 15px;"
                                        >
                                            <b-col>
                                                <GoogleLogin
                                                    :params="params"
                                                    :render-params="renderParams"
                                                    :on-success="(s) => onGoogleSuccess(s)"
                                                    :on-current-user="onGoogleSuccess"
                                                    :on-failure="onGoogleFailure"
                                                />
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </b-form>
                            </b-card-body>
                            <div
                                v-for="error in errors"
                                :key="error.message"
                            >
                                <b-alert
                                    show
                                    :variant="error.variant ? error.variant : 'warning'"
                                    style="margin-bottom: -5px"
                                >
                                    {{ error.message }}
                                    <b-button
                                        v-if="error.message.includes('verify')"
                                        variant="outline-cliovis-grey-extraDark"
                                        class="px-4"
                                        @click="resendEmailVerification"
                                    >
                                        Resend Email
                                    </b-button>
                                    <div
                                        v-if="error.message.includes('verify')"
                                        style="margin-top: 3px"
                                    >
                                        Need additional help? <a
                                            style="color: #396aba; font-weight: 500"
                                            href="mailto:support@cliovis.com"
                                        >support@cliovis.com</a>
                                    </div>
                                </b-alert>
                            </div>
                        </b-card>
                        <!--
							<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
								<b-card-body class="text-center">
									<div>
										<h2>Sign up</h2>
										<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
										<b-button variant="primary" class="active mt-3">Register Now!</b-button>
									</div>
								</b-card-body>
							</b-card>
							-->
                    </b-card-group>
                </b-col>
                <b-col
                    class="large-screens-only-2"
                    md="auto"
                    align-self="center"
                >
                    <b-row class="info-window">
                        <!--<div class="sidebar"/>-->
                        <b-col class="info-window-content">
                            <div style="font-size: 16px; font-weight: 500; margin-left: -5px">
                                <a
                                    href="https://cliovis.com/pricing"
                                    target="_blank"
                                ><i
                                    class="fas fa-exclamation-circle"
                                    style="color: #247a59; font-size: 23px"
                                    aria-label="alert"
                                /></a>
                                Click here for details on <a
                                    href="https://cliovis.com/pricing"
                                    target="_blank"
                                ><span style="font-weight: 600; margin-right: 4px">ClioVis Pricing</span> <i class="fas fa-external-link-alt" /></a>
                            </div>
                            <br>
                            <span style="color: #4d535e">
                                ClioVis enables anyone to combine the best features of digital timelines and mind mapping tools to better
                                understand complex information, organize research, and present findings.
                                <br><br>
                                It also teaches you how to cite sources and differentiate between causation and correlation.
                            </span>
                            <b-btn
                                href="https://cliovis.com/tutorials-and-instructions"
                                target="_blank"
                                style="width: 97%; margin-top: 15px; font-size: 18px"
                                variant="cliovis-blue-light"
                            >
                                <i
                                    class="fas fa-play-circle"
                                    style="margin-right: 5px"
                                /> Watch Tutorials
                            </b-btn>
                            <b-row style="margin-top: 20px">
                                <b-button
                                    href="https://cliovis.com/privacy-policy-2/"
                                    target="_blank"
                                    variant="link-cliovis-grey-dark"
                                    class="px-3"
                                >
                                    <img
                                        class="embedded-btn-icon"
                                        aria-hidden="true"
                                        src="@/assets/icons/external-link-symbol-grey.png"
                                    >privacy policy
                                </b-button>
                                <b-button
                                    href="https://cliovis.com/terms-of-use/"
                                    target="_blank"
                                    variant="link-cliovis-grey-dark"
                                    class="px-4"
                                    style="margin-left: 0px"
                                >
                                    <img
                                        class="embedded-btn-icon"
                                        aria-hidden="true"
                                        src="@/assets/icons/external-link-symbol-grey.png"
                                    >terms of use
                                </b-button>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row
                align-h="end"
                class="text-center py-3"
                style="font-size: 14px;"
            >
                <!-- <b-col cols="4"><b-btn href="https://cliovis.com/support-us/" target="_blank" variant="cliovis-grey-darker" pill class="button-rightside" style="min-height: 32px; line-height: 16px; margin-top: -10px; font-weight: 500"><i class="fas fa-heart"/> Support Us</b-btn></b-col> -->
                <b-col cols="4">
                    &copy; 2024 Copyright: <a
                        href="https://cliovis.com"
                        target="_blank"
                        style="color: #24457a; font-weight: 700"
                    ><span style="color: #396aba"> Clio</span>Vis, LLC</a>
                </b-col>
                <b-col
                    cols="4"
                    class="text-right"
                >
                    ClioVis {{ VersionString }}
                </b-col>
            </b-row>
        </b-container>
        <b-modal
            v-model="showLinkPrompt"
            title="Link Google Account"
            no-close-on-backdrop
            no-close-on-esc
            no-enforce-focus
            centered
            size="lg"
            @ok="onGoogleSuccess(googleSuccessResult, true)"
            @close="googleSignOut"
            @cancel="googleSignOut"
        >
            <p>There is already a ClioVis account associated with this email address.  Would you like to permanently link your Google account with your ClioVis account?</p>
            <p>If you choose to link your account, all of your projects will remain exactly as they are and you can still sign in with your password.  You'll just be able to sign in with your Google account, too!</p>
        </b-modal>
    </div>
</template>
<script lang="js">
import Vue from 'vue';
import GoogleLogin from 'vue-google-login';
import { VersionString, GetAPIUrl, IsProductionEnvironment } from '@/constants/environment';

export default {
    name: 'Login',
    components: {
        GoogleLogin
    },
    data()
    {
        return {
            attemptingLogin: false,
            passwordInputType: "password",
            redirect: "/",
            errors: [],
            googleSuccessResult: null,
            showLinkPrompt: false,
            formData: 
			{
			    username: "",
			    password: ""
			},
            lastUsedUsername: "",
			
            // Google stuff
            // client_id is the only required property but you can add several more params, full list here https://www.npmjs.com/package/vue-google-login
            params: {
                cookie_policy: 'none'
            },
            // only needed if you want to render the button with the google ui
            renderParams: {
                width: 235,
                height: 48,
                longtitle: true
            }
        };
    },
    computed: {
        googleLoginEnabled()
        {
            return true;
        },
    	VersionString()
        {
        	return VersionString;
    	}
    },
    mounted()
    {
        let url = window.location.href;

        if(url.startsWith('https://webapp.cliovis.org'))
        {
            url = url.replace(".org", ".com");
            window.location = url;
        }
    },
    methods: {
        async googleSignOut()
        {
            try
            {
                const auth2 = await Vue.GoogleAuth;
                await auth2.signOut();
            }
            catch(err)
            {
                console.error(err);
            }
        },

        async onGoogleSuccess(arg, linkAccount) 
        {
            this.$set(this, 'googleSuccessResult', arg);
            this.errors.length = 0;
            this.attemptingLogin = true;
            try
            {
                const id_token = arg.getAuthResponse().id_token;
                const response = await this.$http.post('oauth/google/token', { id_token, link: linkAccount ? true : undefined });
                this.handleLoginSuccess(this, response);
            }
            catch(er)
            {
                const resp = er.response;
                if (resp)
                {
                    if (resp.status === 409) 
                    {
                        console.error('response below');
                        console.error(resp);
                        this.showLinkPrompt = true;
                        this.errors.push({ message: 'ClioVis account with that email address already exists', variant:"danger" });
                        return;
                    }
                }

                console.error('Failed to sign in via Google, see below...');
                console.error(er);
                await googleSignOut();
                this.errors.push({ message: 'Failed to sign in via Google', variant:"danger" });
            }
            finally
            {
                this.attemptingLogin = false;
            }
        },
        onGoogleFailure() 
        {},

        keypress(evt)
        {
            // form submit doesn't seem to work here for some reason,
            // so we just listen for keypress w/ Enter 
            if (evt.key == "Enter")
            {
                this.clickLogin();
            }
        },

        clickLogin()
        {
            // easiest way to clear array
            this.errors.length = 0;
    		this.redirect = this.$route.query.redirect || this.redirect;
            this.attemptingLogin = true;
            try
            {
                let form = new FormData();
                form.append('user', this.formData.username);
                form.append('pass', this.formData.password);

                this.lastUsedUsername = this.formData.username;
				
                // Set from the login mixin in main.js
                this.login(this, form);
            }
            catch(err)
            {
                console.error('Login failed');
                console.error(err);
                this.errors.push({ message: 'Failed to log in', variant:"danger" });
            }
            this.attemptingLogin = false;
        },

        clickSignUp()
        {
            this.$router.push('/register');
        },

        clickForgotPassword()
        {
            this.$router.push('/forgotpassword');
        },
        clickPasswordInputType()
        {
            if(this.passwordInputType == "password")
            {
                this.passwordInputType = "text";
            }
            else
            {
                this.passwordInputType = "password";
            }
        },

        async resendEmailVerification()
        {
            let form = new FormData();
            form.append('user', this.lastUsedUsername);
			
            try 
            {
                let res = await this.$http.post('resendemailverification', form);
                if (res.data.error)
                {
                    this.errors.push({ message: res.data.error, variant:"danger" });
                    return;
                }
                alert('Verification email sent!');
            } 
            catch (error) 
            {
                this.errors.push({ message: error, variant:"danger" });
                return;
            }
        },

        /*		// Google Analytics
		track () {
			this.$ga.page('/login')
		}
*/
    }
};
</script>

<style lang="scss" scoped>
.fullheight
{
	height: 93vh;
	min-height: 625px;

	@media (min-width: 900px)
	{
		display: flex;
  		justify-content: center;
  		align-items: center;
	}
}

.info-window
{
	margin-left: 15px;
	height: 68vh;
	min-height: 475px;
	max-height: 550px;
	width: 395px;
	background-color: #fdfaf9;
	box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
	background: linear-gradient(90deg, rgba(251,249,247,1) 46%, rgba(251,249,247,0.5802521692270659) 100%);
	border-left: 3px solid #396aba;;

	.info-window-content{
		font-size: 19.5px;
		display: block;
		margin: auto;
		margin-left: 15px;
	}
}

.embedded-btn-icon
{
	height: 24px;
	width: 24px;
	margin: 8px;
}

.google-btn
{
	width: 250px;
	height: 50px;
	color: black !important;
}

</style>